// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__cQCqY","row":"styles_row__0CGo7","column":"styles_column__7gAqA","resizer":"styles_resizer__DqzZg"};